import logger from '@eb/logger-bugsnag';
import { fetchV3WithTranslateServerErrors } from './base';
import { _validateTaxIdCountry } from './constants';
import { EVENT_DEFAULT_ERROR_MESSAGE } from '../constants';

const ERROR_SPEC = {
    default: () => EVENT_DEFAULT_ERROR_MESSAGE,
};

const DEFAULT_VALIDATE_TAX_ID_TIMEOUT_IN_MILLISECONDS = 3000;

/**
 * @param {string} eventId
 * @param {string} country
 * @param {string} taxId
 * @param [object] options
 * @param [number] options.timeoutInMilliseconds
 * @returns {Promise<{ is_tax_exempt: boolean; valid: boolean; }>}
 */
export const validateTaxId = (
    eventId,
    country,
    taxId,
    {
        timeoutInMilliseconds = DEFAULT_VALIDATE_TAX_ID_TIMEOUT_IN_MILLISECONDS,
    } = {},
) =>
    new Promise((resolve, reject) => {
        const endpoint = _validateTaxIdCountry(eventId, country, taxId);

        const timeoutToken = setTimeout(() => {
            logger.warn(
                'validateTaxId took too long to respond, assuming taxes are valid',
                {
                    endpoint,
                    eventId,
                    country,
                    taxId,
                    timeoutInMilliseconds,
                },
            );

            resolve({
                is_tax_exempt: true,
                valid: true,
            });
        }, timeoutInMilliseconds);

        fetchV3WithTranslateServerErrors(
            ERROR_SPEC,
            _validateTaxIdCountry(eventId, country, taxId),
            {
                method: 'GET',
            },
        )
            .then(({ response }) => resolve(response))
            .catch(reject)
            .finally(() => clearTimeout(timeoutToken));
    });
